<template>
  <div class="banner">
    <PageHeader :title="title" v-if="!isLoading">
      <Button @click="cancel">Отмена</Button>
      <Button :theme-color="'primary'" :disabled="isDisabledSave" @click="save">
        Сохранить
      </Button>
    </PageHeader>

    <VLoader v-if="isLoading"/>
    <div v-else>
      <form @submit.prevent="save" class="banner__form">
        <div class="form-group">
          <LabelRequired :isRequired="false">
            {{ getMessageByLang("nameFull", "Название") }}
          </LabelRequired>
          <div class="form-option-required-wrap">
            <Input v-model="banner.name" placeholder="Это название будет видно только в админ-панели"/>
          </div>
        </div>

        <div class="form-group">
          <ProductPhotos ref="RefPhotos" :maxCountPhotos="1" :notificationText="notificationText" v-if="!banner.image"  />
          <div v-else class="banner-control-img">
            <img :src="banner.image.preview" class="banner-preview"/>
            <Button :svg-icon="trashIcon" @click.prevent="removeImg"/>
          </div>
        </div>

        <div class="form-group">
          <LabelRequired :isRequired="false">
            Текст
          </LabelRequired>
          <div class="form-option-required-wrap">
            <Input v-model="banner.title" placeholder="Введите текст"/>
          </div>
        </div>

        <div class="form-group banner__type-link">
          <h6 class="banner__type-link__title">
            Настройки ссылки
          </h6>

          <div>
            <LabelRequired :isRequired="true">
              Тип
            </LabelRequired>
            <select class="app-select" v-model="banner.linkType" @change="onChangedBannersType">
              <option v-for="bannerType in bannersTypes" :key="bannerType.key" :value="bannerType.key">
                {{ bannerType.name }}
              </option>
            </select>
          </div>

          <div class="banner__type-link__internal-link">
            <div v-if="!selectLink">
              <Button :theme-color="'primary'" :disabled="isDisabledBtnSelectItems"
                      @click="onShowModalItems">
                Выбрать
              </Button>
            </div>
            <div v-else class="banner__type__selected-item">
              <p class="banner__type__selected-item__name">{{ selectLink.name }}</p>
              <Button :svg-icon="trashIcon" @click="clearSelectLink()"/>
            </div>
          </div>
        </div>

        <div class="form-group">
          <LabelRequired>
            Порядок отображения
          </LabelRequired>
          <div class="form-option-required-wrap">
            <Input v-model="banner.sort_order" :placeholder="Порядок"/>
            <p class="form-group-text">
              Меньшее число = выше в списке 0 = автомтически в конец
            </p>
          </div>
        </div>


        <div class="form-group form-group--checkbox">
          <LabelRequired>
            Видимость
          </LabelRequired>
          <Checkbox v-model="banner.visible"/>
        </div>
      </form>
    </div>

    <ModalOfferings v-if="isShowModalOfferings" :type="banner.linkType" @accept="acceptOffering"
                    @cancel="cancelOffering"/>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import {useRoute, useRouter} from "vue-router";
import {getMessageByLang} from "@/utils/translate.js";
import {useAppStore} from "@/stores/app";

import {bannersTypes} from '@/constants/banners'

import PageHeader from "@/components/page/PageHeader.vue";
import LabelRequired from "@/components/forms/LabelRequired.vue";
import {Input} from "@progress/kendo-vue-inputs";
import {Checkbox} from "@progress/kendo-vue-inputs";
import {Button} from "@progress/kendo-vue-buttons";
import ProductPhotos from "@/components/product/ProductPhotos.vue";
import {trashIcon} from "@progress/kendo-svg-icons";
import ModalOfferings from '@/components/modals/ModalOfferings.vue';

import api from '@/api';

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();

const title = ref('Новый баннер');
const isLoading = ref(true);
const bannerId = ref(null);
const banner = ref({
  "name": '',
  "type": '',
  "link": '',
  "visible": true,
  "sort_order": 1,
  file: null,
  title: '',
  linkType: null
});
const RefPhotos = ref(null);
const isShowModalOfferings = ref(false);
const selectLink = ref(null);

const notificationText = 'Поддерживаемые форматы изображений: JPEG, PNG, JPG, WEBP'

const onChangedBannersType = () => {
  selectLink.value = null;
}

const isDisabledBtnSelectItems = computed(() => {
  return !banner.value?.linkType;
})

const onShowModalItems = () => {
  isShowModalOfferings.value = true;
}

const clearSelectLink = () => {
  selectLink.value = null;
}

const acceptOffering = (item) => {
  selectLink.value = item;
  isShowModalOfferings.value = false;
}

const cancelOffering = () => {
  isShowModalOfferings.value = false;
}

const getBanner = async () => {
  try {
    isLoading.value = true;

    const {data} = await api.banner.get(bannerId.value);

    banner.value = {
      ...data.data,
      sort_order: Number(data?.data?.sort_order) || 0,
      linkType: data?.data?.bannerable_type || null
    };
    title.value = `Редактирование ${banner.value.name}`

    if (data?.data?.bannerable?.id) {
      selectLink.value = {
        name: data.data.bannerable.name,
        id: data.data.bannerable.id
      }
    }

  } catch (err) {
    console.error(err)
    appStore.showNotification('Ошибка при получении баннера');

  } finally {
    isLoading.value = false;
  }
}

const isValidBanner = () => {
  const messages = []

  if (!banner.value.name || !banner.value.name.trim()) {
    messages.push('Укажите пожалуйста название');
  }

  return messages;
}

const save = async () => {
  try {
    console.log('banner', banner.value)

    const bannerValidationMessages = isValidBanner();

    let images = null;
    if (!banner.value?.id) {
      images = RefPhotos.value.getPhotos();
    } else {
      if (RefPhotos?.value?.getPhotos()) {
        images = RefPhotos?.value?.getPhotos();
      } else {
        images = null;
      }
    }

    if (images && Array.isArray(images) && !images[0]) {
      appStore.showNotification('Изображение баннера необходима для сохранения');
      return;
    }

    if (bannerValidationMessages.length > 0) {
      appStore.showNotification(bannerValidationMessages[0]);
      return;
    }

    if (!selectLink.value?.id) {
      appStore.showNotification('Выберите пожалуйста товар или услугу');
      return;
    }

    isLoading.value = true;

    const formData = new FormData();
    formData.append('name', banner.value.name.trim());
    formData.append('type', banner.value.linkType);
    formData.append('link', selectLink.value?.id || '');
    formData.append('visible', banner.value.visible ? '1' : '0');
    formData.append('sort_order', banner.value.sort_order || 1);
    formData.append('title', banner.value.title || '');

    if(banner.value?.id) {
      formData.append('_method', 'PUT');
    }

    if (images && images[0]) {
      formData.append('image', images[0], images[0].name);
    }

    if (!banner.value.id) {
      await api.banner.create(formData);
    } else {
      await api.banner.edit(formData, banner.value.id);
    }

    const message = banner.value.id
        ? 'Изменения сохранены'
        : 'Баннер успешно создан';

    appStore.showNotification(message, 'success');
    router.push(`/admin/banners`);

  } catch (err) {
    console.error(err);

    const message = banner.value.id
        ? 'Ошибка при сохранении баннера'
        : 'Ошибка при создании баннера';

    appStore.showNotification(message);

  } finally {
    isLoading.value = false;
  }
}

const removeImg = () => {
  banner.value.image = null;
}

const isDisabledSave = computed(() => {
  if (!banner.value.id) {
    return isValidBanner().length > 0
  }

  return false;
})

const cancel = () => {
  router.push('/admin/banners');
}


onMounted(() => {
  bannerId.value = route?.params?.id || null;

  if (bannerId.value !== 'new') {
    getBanner();
    return
  }

  isLoading.value = false;
})
</script>

<style lang="scss" scoped>
.banner {
  &__form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  & .banner-preview {
    width: 300px;
    height: 169px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 2px solid white;
  }
}

.banner-control-img {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
</style>

<style lang="scss">
.banner__type-link {
  background: rgba(204, 204, 204, .3);
  padding: 1rem;
  border: 1px solid #ccc;

  &__title {
    margin: 0 0 1rem;
    font-size: 16px;
    color: #000;
  }

  &__internal-link {
    margin-top: 1rem;
  }
}

.banner__type__selected-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>